import React, { ComponentProps } from "react";

export default function ExpandIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      {...props}
    >
      <path
        d="M0.487607 4.23152C0.756961 4.23152 0.975213 4.0132 0.975213 3.74391V1.66488L4.11572 4.80475C4.21097 4.89993 4.33573 4.94752 4.4605 4.94752C4.58532 4.94752 4.71015 4.89993 4.80533 4.80468C4.99576 4.61425 4.99576 4.3055 4.80527 4.11514L1.66462 0.975213H3.7441C4.01339 0.975213 4.23171 0.756896 4.23171 0.487607C4.23171 0.218318 4.01346 0 3.7441 0H0.487607C0.218253 0 0 0.218318 0 0.487607V3.74397C0 4.0132 0.218253 4.23152 0.487607 4.23152Z"
        fill="white"
      />
      <path
        d="M13.5133 9.76839C13.2439 9.76839 13.0257 9.98671 13.0257 10.256V12.3351L9.78848 9.0979C9.59799 8.90747 9.2893 8.90747 9.09887 9.0979C8.90845 9.28832 8.90845 9.59708 9.09887 9.78744L12.336 13.0246H10.257C9.98768 13.0246 9.76943 13.2429 9.76943 13.5122C9.76943 13.7815 9.98768 13.9998 10.257 13.9998H13.5133C13.7827 13.9998 14.0009 13.7815 14.0009 13.5122V10.256C14.0009 9.98671 13.7826 9.76839 13.5133 9.76839Z"
        fill="white"
      />
      <path
        d="M4.21305 9.09791L0.97619 12.335V10.256C0.97619 9.98672 0.757937 9.7684 0.488583 9.7684C0.219229 9.7684 0.000976562 9.98672 0.000976562 10.256V13.5123C0.000976562 13.7816 0.219229 13.9999 0.488583 13.9999H3.74476C4.01404 13.9999 4.23236 13.7816 4.23236 13.5123C4.23236 13.243 4.01411 13.0247 3.74476 13.0247H1.66573L4.90266 9.78745C5.09309 9.59702 5.09309 9.28827 4.90259 9.09784C4.7123 8.90748 4.40354 8.90748 4.21305 9.09791Z"
        fill="white"
      />
      <path
        d="M13.5138 0H10.2575C9.98814 0 9.76988 0.218318 9.76988 0.487607C9.76988 0.756895 9.98814 0.975213 10.2575 0.975213H12.3366L9.19652 4.11546C9.0061 4.30589 9.0061 4.61464 9.19659 4.80507C9.29177 4.90025 9.4166 4.94784 9.54136 4.94784C9.66612 4.94784 9.79095 4.90019 9.88619 4.805L13.0262 1.66475V3.74391C13.0262 4.0132 13.2445 4.23151 13.5139 4.23151C13.7832 4.23151 14.0015 4.0132 14.0015 3.74391V0.487607C14.0014 0.218253 13.7831 0 13.5138 0Z"
        fill="white"
      />
    </svg>
  );
}
